// Fila „Profil” a instructorului, în stilul profilului elevului: plăcuțele InputUI.Group, alegerile
// (culoarea, tipul, cutia) în plăcuțe cu ChoiceUI, butoanele în ButtonUI.Row. Câmpurile depind de
// tip: instructorul de schimb n-are sector, mașină și cutie. „Poate examen” nu mai e separat — e
// tipul „Examen” (comutatorul punea oricum tipul pe Examen și invers).
import React from "react";

import DistrictsDatalist from "../../Common/DistrictsDatalist";
import { ACCOUNT_DELETE_CONFIRM_TITLE } from "../../../constants/accountDeletion";
import { instructorTypeHasCar, normalizeInstructorType } from "../../../constants/instructors";
import { ButtonUI, ChoiceUI, InputUI } from "../../UI";
import { PROFILE_COLOR_PALETTE, EDITABLE_INSTRUCTOR_TYPE_OPTIONS } from "./instructorProfileShared";

export const GEARBOX_OPTIONS = [
   { value: "manual", label: "Manuală" },
   { value: "automat", label: "Automată" },
];

export default function InstructorMainTab({
   formData,
   handleFormChange,
   handleSaveEdit,
   saveError,
   saving,
   deleting = false,
   canDelete = false,
   canSetPassword = false,
   handleDeleteInstructor,
   handleResetProfile,
   activeColorIndex,
   setColorFromIndex,
   setProfileDirty,
   setFormData,
}) {
   const instructorType = normalizeInstructorType(formData.instructorType);
   const hasCar = instructorTypeHasCar(instructorType);
   const busy = saving || deleting;

   const setField = (field, value) => {
      setProfileDirty(true);
      setFormData((current) => ({ ...current, [field]: value }));
   };

   return (
      <form
         className="staffProfileForm"
         onSubmit={(event) => {
            event.preventDefault();
            handleSaveEdit();
         }}
      >
         <InputUI.Group columns={2}>
            <InputUI label="Prenume" name="firstName" value={formData.firstName} onChange={handleFormChange} placeholder="Prenume" autoComplete="given-name" />
            <InputUI label="Nume" name="lastName" value={formData.lastName} onChange={handleFormChange} placeholder="Nume" autoComplete="family-name" />
            <InputUI label="Telefon" name="phone" type="tel" value={formData.phone} onChange={handleFormChange} placeholder="Telefon" autoComplete="tel" />
            <InputUI label="ID instructor" name="instructorIdField" value={formData.instructorIdField} onChange={handleFormChange} placeholder="ID instructor" />
            <InputUI full label="Email" name="email" type="email" value={formData.email} onChange={handleFormChange} placeholder="Email" autoComplete="email" />

            {canSetPassword ? (
               <InputUI
                  full
                  label="Parolă nouă"
                  name="newPassword"
                  type="password"
                  value={formData.newPassword || ""}
                  onChange={handleFormChange}
                  placeholder="Gol = rămâne parola actuală"
                  autoComplete="new-password"
                  hint="Contul trece la alt om: parola veche nu mai merge, contul iese de pe toate dispozitivele."
               />
            ) : null}

            <InputUI as="text" full label="Tip" className="staffProfileForm__choice">
               <ChoiceUI
                  look="segmented"
                  aria-label="Tipul instructorului"
                  value={instructorType}
                  options={EDITABLE_INSTRUCTOR_TYPE_OPTIONS}
                  disabled={busy}
                  onChange={(value) => {
                     setProfileDirty(true);
                     setFormData((current) => ({
                        ...current,
                        instructorType: value,
                        // examenul ține de tip: Examen = poate examina
                        isExamen: value === "EXAMEN" ? true : current.instructorType === "EXAMEN" ? false : current.isExamen,
                     }));
                  }}
               />
            </InputUI>

            {hasCar ? (
               <>
                  <InputUI
                     label="Sector"
                     name="sector"
                     value={formData.sector}
                     onChange={handleFormChange}
                     placeholder="Sector"
                     list="instructor-profile-districts"
                  />
                  <InputUI label="Nr. mașină" name="carPlate" value={formData.carPlate} onChange={handleFormChange} placeholder="Nr. mașină" />
                  <InputUI as="text" full label="Cutie" className="staffProfileForm__choice">
                     <ChoiceUI
                        look="segmented"
                        aria-label="Cutia de viteze"
                        value={formData.gearbox === "automat" ? "automat" : "manual"}
                        options={GEARBOX_OPTIONS}
                        disabled={busy}
                        onChange={(value) => setField("gearbox", value)}
                     />
                  </InputUI>
               </>
            ) : null}

            <InputUI as="text" full label="Culoare" className="staffProfileForm__choice">
               <ChoiceUI
                  look="swatches"
                  aria-label="Culoarea profilului"
                  value={String(activeColorIndex)}
                  options={PROFILE_COLOR_PALETTE.map((color, index) => ({
                     value: String(index),
                     label: color.token.replace(/^--/, ""),
                     title: color.token.replace(/^--/, ""),
                     color: color.visual,
                  }))}
                  disabled={busy}
                  onChange={(value) => setColorFromIndex(Number(value))}
               />
            </InputUI>
         </InputUI.Group>
         {hasCar ? <DistrictsDatalist id="instructor-profile-districts" /> : null}

         {saveError ? <p className="staffProfileForm__error">{saveError}</p> : null}

         <ButtonUI.Row>
            {canDelete ? (
               <ButtonUI
                  variant="danger"
                  disabled={busy}
                  confirm={deleting ? "Se șterge..." : "Da, șterge"}
                  confirmTitle={ACCOUNT_DELETE_CONFIRM_TITLE}
                  cancelLabel="Nu"
                  onClick={handleDeleteInstructor}
               >
                  {deleting ? "Se șterge..." : "Șterge"}
               </ButtonUI>
            ) : null}
            <ButtonUI type="submit" variant="primary" disabled={busy} loading={saving}>
               {saving ? "Salvez..." : "Salvează"}
            </ButtonUI>
            <ButtonUI onClick={handleResetProfile} disabled={busy}>
               Resetează
            </ButtonUI>
         </ButtonUI.Row>
      </form>
   );
}
